import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StoreData } from './store-data';

@Injectable({
  providedIn: 'root'
})
export class ShareDataService {
  private shareData = new BehaviorSubject<any>({});
  currentShareData = this.shareData.asObservable();

  constructor() { }
   changeData(data: StoreData) {
    this.shareData.next(data);
  }
}
